export const ROOT_SLICE_DASH_CISV = 'DashboardCISV';